import mgmtVariant from "src/services/mgmtVariant";

// Action Types
export const VARIANTS_INFO = '@variant/info';

export const VARIANT_CREATE = '@variant/create';
export const VARIANT_CREATE_SUCCESS = '@variant/create-success';
export const VARIANT_CREATE_FAILURE = '@variant/create-failure';

export const VARIANT_UPDATE_SUCCESS = "@variant/update-success";
export const VARIANT_UPDATE_FAILED = "@variant/update-failed";


// Fetch Variant Products
export function fetchVariantProducts(customerId, categoryId) {

  console.log(
    "fetchVariantProducts() : ",
    customerId,
    categoryId
  );

  return async (dispatch) => {

    try {

      dispatch({ type: VARIANTS_INFO });

      const variants =
        await mgmtVariant.getVariantProducts(
          customerId,
          categoryId
        );

      dispatch({
        type: VARIANT_CREATE_SUCCESS,
        payload: {
          variants,
        },
      });

    } catch (error) {

      dispatch({ type: VARIANT_CREATE_FAILURE });

      throw error;

    }
  };
}


// Update Variant
export function updateVariant(variantInfo) {

  return async (dispatch) => {

    try {

      const variant =
        await mgmtVariant.updateVariant(
          variantInfo
        );

      dispatch({
        type: VARIANT_UPDATE_SUCCESS,
        payload: {
          variant
        }
      });

    } catch (error) {

      dispatch({
        type: VARIANT_UPDATE_FAILED
      });

      throw error;

    }
  };
}